module.exports = __webpack_public_path__ + "static/media/chatwhite.01657489.svg";